export default __webpack_public_path__ + "static/speaker-a75b08e1842993587549a0bfceeae881.png";